(() => {
  const styleId = 'vesta-blog-chat-position';
  let observer;

  const protectArticleControls = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat?.shadowRoot) return false;
    if (chat.shadowRoot.getElementById(styleId)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .activator-nudge {
        right: max(2rem, env(safe-area-inset-right)) !important;
        bottom: max(7.2rem, calc(2rem + env(safe-area-inset-bottom))) !important;
      }

      @media (min-width: 750px) {
        .activator-nudge {
          right: 3.2rem !important;
          bottom: 3.2rem !important;
        }
      }
    `;
    chat.shadowRoot.appendChild(style);
    observer?.disconnect();
    return true;
  };

  if (protectArticleControls()) return;

  observer = new MutationObserver(protectArticleControls);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
